// File Metadata:
// Filename: ThemeToggle.jsx
// Version: 1.00
// Created: 2026-06-14
// Last Modified: 2026-06-14
// Authors: GitHub Copilot
// Description: Theme toggle button component for switching between light, dark, and system themes

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DevicesIcon from '@mui/icons-material/Devices';
import { alpha, useTheme } from '@mui/material/styles';

const ThemeToggle = ({ mode, toggleTheme, themeLabel }) => {
  const theme = useTheme();
  
  const themeIcon = mode === 'light' ? <LightModeIcon fontSize="small" />
                  : mode === 'dark'  ? <DarkModeIcon fontSize="small" />
                  : <DevicesIcon fontSize="small" />;

  return (
    <Tooltip title={`Theme: ${themeLabel}`} placement="bottom">
      <IconButton
        size="small"
        onClick={toggleTheme}
        color="inherit"
        sx={{
          width: 36,
          height: 36,
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.18),
          },
        }}
      >
        {themeIcon}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
